export default "__VITE_ASSET__0YSbbf2K__"